// extracted by mini-css-extract-plugin
module.exports = {"notebookContainer":"Notebook_notebookContainer__28GKW","notebookWrapper":"Notebook_notebookWrapper__1QhQx","sliderWrapper":"Notebook_sliderWrapper__xDmVp"};